import PropTypes from 'prop-types';

export const defaultContact =  {
  over18: false,
  relation: "",
  firstName: "",
  lastName: "",
  email: "",
  phone: ""
};

export const contactProptype = PropTypes.shape({
  over18: PropTypes.bool,
  relation: PropTypes.string,
  firstName: PropTypes.string,
  lastName: PropTypes.string,
  email: PropTypes.string,
  phone: PropTypes.string
});

export const defaultPatient = {
  firstName: "",
  lastName: "",
  dob: "",
  gender: "",
  maritalStatus: "",
  ssn: "",
  address1: "",
  address2: "",
  city: "",
  state: "",
  zip: "",
  email: "",
  phone: ""
};

export const patientPropType = PropTypes.shape({
  firstName: PropTypes.string,
  lastName: PropTypes.string,
  dob: PropTypes.string,
  gender: PropTypes.string,
  maritalStatus: PropTypes.string,
  ssn: PropTypes.string,
  address1: PropTypes.string,
  address2: PropTypes.string,
  city: PropTypes.string,
  state: PropTypes.string,
  zip: PropTypes.string,
  email: PropTypes.string,
  phone: PropTypes.string
})

export const defaultAppointment = {
  reason: "",
  diagnosis: "",
  department: "",
  location: "",
  provider: "",
  type: "",
  day: 0,     // Bitmapped, Monday=1... Friday=16, no preferrence=0
  time: 0,    // Bitmapped, AM=1... PM=2, no preferrence=0
  translationInterpretationServices: {
    needServices: false,
    whichService: "",
    language: ""
  },
  referringPhysician: {
    haveReferringPhys: false,
    firstName: "",
    lastName: "",
    phone: ""
  }
};

export const appointmentProptype = PropTypes.shape({
  reason: PropTypes.string,
  diagnosis: PropTypes.string,
  provider: PropTypes.string,
  department: PropTypes.string,
  location: PropTypes.string,
  type: PropTypes.string,
  day: PropTypes.number,   // Bitmapped, Monday=1... Friday=16, no preferrence=0
  time: PropTypes.number,  // Bitmapped, AM=1... PM=2, no preferrence=0
  translationInterpretationServices: PropTypes.shape({
    needServices: PropTypes.bool,
    whichService: PropTypes.string,
    language: PropTypes.string
  }),
  referringPhysician: PropTypes.shape({
    haveReferringPhys: PropTypes.bool,
    firstName: PropTypes.string,
    lastName: PropTypes.string,
    phone: PropTypes.string
  }),
  paymentMethod:  PropTypes.string  // "", "out-of-pocket", "insurance"
});

export const defaultBilling = {
  relation: "",
  firstName: "",
  lastName: "",
  email: "",
  dob: "",
  address1: "",
  address2: "",
  city: "",
  state: "",
  zip: ""
}

export const billingPropType = PropTypes.shape({
  relation: PropTypes.string,
  firstName: PropTypes.string,
  lastName: PropTypes.string,
  email: PropTypes.string,
  dob: PropTypes.string,
  address1: PropTypes.string,
  address2: PropTypes.string,
  city: PropTypes.string,
  state: PropTypes.string,
  zip: PropTypes.string
});

export const defaultInsurance = {
  company: "",
  policyNumber: "",
  policyType: null,
  group: "",
  whereToSend: null,
  billing: defaultBilling,
  policyHolder: {
    relation: "",
    firstName: "",
    lastName: "",
    dob: "",
    email: ""
  }
}

export const insurancePropType = PropTypes.shape({
  company: PropTypes.string,
  policyType: PropTypes.string,
  policyNumber: PropTypes.string,
  group: PropTypes.string,
  whereToSend: PropTypes.string,
  billing: billingPropType,
  policyHolder: PropTypes.shape({
    relation: PropTypes.string,
    firstName: PropTypes.string,
    lastName: PropTypes.string,
    dob: PropTypes.string,
    email: PropTypes.string
  })
});

export const defaultState = {
  acknowledgedWhatToExpect: false,
  forMe: false,
  patientSeenRecently: false,
  contact: defaultContact,
  patient: defaultPatient,
  appointment: defaultAppointment,
  paymentMethod: "",
  insurance: defaultInsurance,
  pfaCallbackWindowDismissed: false,
  requestResults: ""
};

export const statePropType = PropTypes.shape({
  acknowledgedWhatToExpect: PropTypes.bool,
  forMe: PropTypes.bool,
  patientSeenRecently: PropTypes.bool,
  contact: contactProptype,
  patient: patientPropType,
  appointmentProptype: defaultAppointment,
  paymentMethod: PropTypes.string,
  insurance: insurancePropType,
  pfaCallbackWindowDismissed: PropTypes.bool,
  requestResults: PropTypes.string
});
